// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"styles_footerContainer__fOuRv"};